import type { IconData } from '@stacksjs/iconify-core'

export const chessPawnFlat: IconData = {
  "body": "<g fill=\"none\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path fill=\"#8fbffa\" d=\"M14.5 11a9.5 9.5 0 1 1 15.197 7.603a186 186 0 0 1 1.914 7.28c.974 4.04 2.045 9.09 2.642 13.853a8 8 0 0 0-.99-.096C31 39.564 27.922 39.5 24 39.5s-7.001.064-9.263.14q-.508.017-.99.096c.597-4.762 1.668-9.813 2.642-13.853a186 186 0 0 1 1.914-7.28A9.49 9.49 0 0 1 14.5 11\"/><path fill=\"#2859c5\" d=\"M38.203 45.591c.175-.382.297-.852.297-1.183c0-1.487-.576-2.674-1.546-3.492c-.958-.81-2.264-1.229-3.691-1.276c-2.262-.076-5.34-.14-9.263-.14s-7 .064-9.262.14c-1.428.047-2.734.467-3.692 1.276c-.97.819-1.546 2.005-1.546 3.492c0 .33.122.8.297 1.183c.09.195.208.4.36.566c.144.157.381.343.703.343h26.28c.322 0 .559-.186.703-.343a2.2 2.2 0 0 0 .36-.566\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default chessPawnFlat
